import {getNetworkSocket} from '../networkSocket';

// Отправляет реакцию от лица бота: WS SEND_REACTION с переопределением
// fromPlayerId (сервер примет его, только если это реальный бот того же
// лобби — см. server/index.js). Общая точка для всех механик, отправляющих
// реакции "от бота" (BotReactionsSimulator, ответные реакции ботов из
// ReactionsPanel)
export const sendBotReaction = (lobbyId, botId, toPlayerId, reactionType) => {
  const ws = getNetworkSocket();
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({
      type: 'SEND_REACTION',
      payload: {lobbyId, toPlayerId, reactionType, fromPlayerId: botId},
    }));
  }
};
